import { createContext } from 'react';

const NotificacionesFinanzasContext = createContext();

export default NotificacionesFinanzasContext;
